import { getInvoiceCreditDetail } from '@/api/clearing/invoice'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { queryTitlesByCmpIdx } from '@/api/partner/title'

export class InvoiceUtils {
  // 初始化开票抬头、收票抬头
  static async initTitlesMap(charges, view) {
    // 初始化开票抬头
    let titleMap = {}
    const accountIds = Array.from(new Set(Array.from(charges, p => p.accountId)))
    if (!accountIds || accountIds.length <= 0) {
      return
    }
    const res = await queryTitlesByCmpIdx(accountIds)
    titleMap = res.data
    if (!titleMap) {
      return
    }
    accountIds.forEach(id => {
      if (titleMap[id]) {
        view.customerTitles = [...view.customerTitles, ...titleMap[id]]
      }
    })
  }

  static invoiceDateChange(view) {
    getInvoiceCreditDetail({ keys: [view.properties.invoice.uuid], anyDate: view.properties.invoice.invoiceDate }).then(res => {
      view.properties.invoice.incomePayDate = ''
      for (const item of res.data) {
        if (item.invoiceUuid === view.properties.invoice.uuid) {
          view.properties.invoice.incomePayDate = item.incomePayDate
          break
        }
      }
      view.incomePayDate = view.properties.invoice.incomePayDate ? view.properties.invoice.incomePayDate.substr(0, 10) : ''
    })
  }

  // 应付发票开票抬头修改
  static apTitleChangeEvent(invoice, titleItem) {
    invoice.title = titleItem.title
    if (titleItem.title && titleItem.uuid) {
      invoice.taxAccount = titleItem.taxAccount
    }
  }

  // 应付发票收票抬头修改
  static apReceiptInvoiceTitleChangeEvent(invoice, titleItem) {
    invoice.receiptInvoiceTitle = titleItem.invoiceTitle
    if (titleItem.invoiceTitle && titleItem.uuid) {
      invoice.buyerTaxAccount = titleItem.taxAccount
    }
  }
  // 应付发票发票性质修改
  static apInvoiceNatureChangeEvent(invoice, value) {
    invoice.invoiceNature = value
    if (invoice.invoiceNature && invoice.invoiceNature !== InvoiceConstant.INVOICE_NATURE_NORMAL.code) {
      invoice.taxRate = 0
      // 税率改变
      InvoiceUtils.taxRateChangeHandler(invoice)
    }
  }
  // 税率
  static taxRateChangeHandler(invoice) {
    // 不含税金额
    const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(invoice.amount / (invoice.taxRate / 100 + 1), invoice.currency), 2)
    invoice.excludingTaxAmount = rAmount
    invoice.taxAmount = RateUtil.getAmountByCurrency(invoice.amount - rAmount, invoice.currency)
  }

  // 计算不含税
  static taxAmountChangeHandler(invoice, value, view) {
    value = InvoiceUtils.numFormatFunction2(invoice, value)
    view.$nextTick(() => {
      invoice.taxAmount = RateUtil.getAmountByCurrency(value, invoice.currency)
      invoice.excludingTaxAmount = RateUtil.getAmountByCurrency(invoice.amount - invoice.taxAmount, invoice.currency)
    })
  }
  // 不含税、税额范围
  static numFormatFunction2(invoice, value) {
    let max = invoice.amount
    let min = 0
    if (invoice.amount < 0) {
      max = 0
      min = invoice.amount
    }
    if (value > max) {
      value = max
    }
    if (value < min) {
      value = min
    }
    return value
  }
}
